import { TEXT_MONTHS_ABBREVIATION, TEXT_MONTHS_FULLNAME } from './constants';
import type {
  GetFormattedDateString,
  GetFormattedDateStringWithType,
} from './types';

export const getFormattedDateString: GetFormattedDateString = (dateString, textMonthType, separator = ' ') => { // @suppress longLineCheck
  if (!dateString || typeof dateString !== 'string') {
    return '';
  }
  const textMonth = textMonthType === 'fullName'
    ? TEXT_MONTHS_FULLNAME
    : TEXT_MONTHS_ABBREVIATION;

  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate().toString().padStart(2, '0');
  const formattedDate = `${day}${separator}${textMonth[month]}${separator}${year}`;
  return formattedDate;
};

export const getFormattedDateStringWithType: GetFormattedDateStringWithType = (
  date,
  textMonthType,
  formatType,
  separator = ' ',
) => {
  const formattedDate = getFormattedDateString(date, textMonthType, separator);

  if (formatType === 'mmYYYY') {
    return formattedDate.split(separator).slice(1, 2).join(separator);
  }

  if (formatType === 'ddMM') {
    return formattedDate.split(separator).slice(0, 2).join(separator);
  }

  return formattedDate;
};
